import { PageHeader, Space } from 'antd';
import { Table, Filters } from './components';

const SmallFleets = () => (
    <PageHeader
        title="Small Fleets"
        style={{ padding: '32px 24px 24px 0' }}
        footer={(
            <Space direction="vertical" size={24} style={{ width: '100%' }}>
                <Filters />
                <Table />
            </Space>
        )}
    />
);

export default SmallFleets;
